import { Placement } from './Placement';
import { SSRTextPlacementContent } from './SSRTextPlacementContent';

export  class GeneratePlacementResponse {
    'placements': Array<Placement>;
    'placementContent'?: Array<SSRTextPlacementContent>;
    static readonly discriminator: string | undefined;
    static readonly attributeTypeMap: Array<{
        name: string;
        baseName: string;
        type: string;
        format: string;
    }>;
}
